import { useEffect, useState } from 'react'
import { registryService } from 'services'
import { IProfileType } from 'interfaces'

function useProfileTypes(setError?: (error: any) => void) {
  const [profileTypes, setProfileTypes] = useState<IProfileType[]>([])

  useEffect(() => {
    const controller = registryService.getProfileTypes(setProfileTypes, setError)
    return () => controller.abort()
  }, [setError])

  return profileTypes
}

export default useProfileTypes
